import Vue from 'vue'

const state = {
  items: {}
}

const mutations = {
  FETCH (state, currencies) {
    state.items = currencies
  }
}

const actions = {
  fetchAll: ({commit}) => {
    return Vue.prototype.$axios.get('currencies')
      .then(response => {
        commit('FETCH', response.data)
      })
  }
}

const getters = {
  getCurrencyById: state => currencyID => {
    return state.items[currencyID]
  },
  getDefaultCurrency: (state, getters, rootState) => {
    /* var currency = state.items[rootState.settings.currency]
    if (currency) {
      return currency
    } */
    return Object.values(state.items).find(item => {
      return item.symbol === 'EUR'
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
